import { SET_PRODUCTS, SET_PRODUCT, SET_PRODUCTS_CART } from "../actionTypes"

const initialState = {
  productsObject: {},
  products: [],
  product: {},
  productsCart: []
}

const productsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PRODUCTS:
      return {
        ...state,
        products: action.products.data,
        productsObject: action.products
      }
    case SET_PRODUCT:
      return {
        ...state,
        product: action.product,
      }
    case SET_PRODUCTS_CART:
      return {
        ...state,
        productsCart: action.productsCart,
      }
    default:
      return state
  }
}

export default productsReducer